angular.module('dpw.components')
  .directive('dpwFlipper', [function() {
    return {
      restrict: 'A',
      transclude: true,
      scope: { isFlipped: '@' },
      templateUrl: 'dpw-flipper.html'
    }
  }]);